(() => {
  const configNode = document.getElementById('PurchaseConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const strings = config.strings;
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const money = value => new Intl.NumberFormat('en-AE', { style: 'currency', currency: config.currency, minimumFractionDigits: 2 }).format(value / 100);
  let cart = config.cart;
  let queue = Promise.resolve();
  let pending = 0;
  let uncertain = false;
  const enqueue = task => {
    pending++;
    renderCart();
    document.querySelectorAll('[data-checkout-form] button').forEach(button => button.disabled = true);
    const next = queue.then(task);
    queue = next.catch(() => {}).finally(() => {
      pending--;
      renderCart();
      document.querySelectorAll('[data-checkout-form] button').forEach(button => button.disabled = pending > 0 || uncertain);
    });
    return next;
  };
  function deliveryDate(now = new Date()) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Dubai', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' }).formatToParts(now).map(p => [p.type, p.value]));
    const pickup = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
    if (Number(parts.hour) >= 12) pickup.setUTCDate(pickup.getUTCDate() + 1);
    while (pickup.getUTCDay() === 0) pickup.setUTCDate(pickup.getUTCDate() + 1);
    const delivery = new Date(pickup);
    delivery.setUTCDate(delivery.getUTCDate() + 1);
    if (delivery.getUTCDay() === 0) delivery.setUTCDate(delivery.getUTCDate() + 2);
    return delivery;
  }
  function renderDates() {
    const date = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(deliveryDate());
    document.querySelectorAll('[data-delivery-date]').forEach(node => node.textContent = date);
  }
  function whatsappMessage() {
    const lines = ['Hi I would like to order', ''];
    cart.items.forEach((item, index) => {
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? ' (' + item.variant_title + ')' : '';
      lines.push((index + 1) + '. ' + (item.product_title || item.title) + variant + ' — Qty ' + item.quantity + ' × ' + money(item.final_price) + ' = ' + money(item.final_line_price));
    });
    const fee = cart.item_count > 0 && cart.item_count < 4 ? 1000 : 0;
    lines.push('', 'Items total: ' + money(cart.total_price), fee === 0 ? 'Free delivery' : 'Delivery charge: ' + money(fee), 'Total: ' + money(cart.total_price + fee));
    return lines.join('\n');
  }
  function renderCart() {
    document.querySelectorAll('[data-cart-photos]').forEach(node => {
      node.replaceChildren();
      cart.items.forEach(item => {
        const box = document.createElement('span');
        box.className = 'sticky-cart-photo';
        const source = item.featured_image?.url || item.image;
        if (source) {
          const img = document.createElement('img');
          const url = new URL(source, location.origin);
          url.searchParams.set('width', '96');
          img.src = url.href;
          img.alt = item.product_title || item.title;
          img.width = 40;
          img.height = 40;
          box.append(img);
        }
        node.append(box);
      });
    });
    const remaining = Math.max(0, 4 - cart.item_count);
    document.querySelectorAll('[data-cart-progress]').forEach(node => node.textContent = Math.min(4, cart.item_count) + '/4');
    document.querySelectorAll('[data-cart-progress-message]').forEach(node => node.textContent = remaining ? (remaining === 1 ? strings.add_one : strings.add_more.replace('{{ count }}', remaining)) : strings.free);
    document.querySelectorAll('[data-cart-progress-bar]').forEach(node => node.style.width = Math.min(4, cart.item_count) * 25 + '%');
    const deliveryFee = cart.item_count > 0 && cart.item_count < 4 ? 1000 : 0;
    document.querySelectorAll('[data-whatsapp-order]').forEach(node => {
      node.href = 'https://wa.me/971509755800?text=' + encodeURIComponent(whatsappMessage());
      node.setAttribute('aria-disabled', String(pending > 0 || uncertain || !cart.item_count));
    });
    document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = cart.item_count);
    document.querySelectorAll('[data-cart-total]').forEach(node => node.textContent = money(cart.total_price));
    document.querySelectorAll('[data-free-delivery]').forEach(node => node.textContent = cart.item_count >= 4 ? strings.free : strings.free_hint);
    document.querySelectorAll('[data-delivery-charge]').forEach(node => {
      node.textContent = deliveryFee === 0 ? strings.shipping_free : money(deliveryFee);
      node.classList.toggle('delivery-free', deliveryFee === 0);
    });
    document.querySelectorAll('[data-payable-total]').forEach(node => node.textContent = money(cart.total_price + deliveryFee));
  }
  function showToast(message) {
    const node = document.querySelector('[data-purchase-toast]');
    node.textContent = message;
    node.hidden = false;
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => node.hidden = true, 3500);
  }
  function bundledCart(result) {
    const html = result.sections?.['purchase-state'];
    if (!html) return null;
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return JSON.parse(doc.querySelector('[data-cart-state]').textContent);
    } catch { return null; }
  }
  async function requestCart(path, payload) {
    const response = await fetch(root + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...payload, sections: ['purchase-state'], sections_url: root + 'cart' }) });
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(result.description || strings.error);
    let fresh = bundledCart(result);
    if (!fresh) {
      const retry = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!retry.ok) {
        uncertain = true;
        document.querySelectorAll('[data-cart-total], [data-delivery-charge], [data-payable-total]').forEach(node => node.textContent = strings.pending);
        throw new Error(strings.sync_error);
      }
      fresh = await retry.json();
    }
    uncertain = false;
    cart = fresh;
    renderCart();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    return cart;
  }
  async function refreshCartPage() {
    const old = document.querySelector('[data-cart-section]');
    if (!old) return;
    const focused = document.activeElement?.id;
    const url = new URL(root + 'cart', location.origin);
    url.searchParams.set('section_id', old.dataset.sectionId);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(strings.error);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const fresh = doc.querySelector('[data-cart-section]');
    if (!fresh) throw new Error(strings.error);
    old.replaceWith(fresh);
    renderCart();
    renderDates();
    document.querySelectorAll('[data-checkout-form] button').forEach(button => button.disabled = pending > 0 || uncertain);
    if (focused) document.getElementById(focused)?.focus();
  }
  async function changeCart(form, quantity) {
    const section = form.closest('[data-cart-section]');
    section?.setAttribute('aria-busy', 'true');
    form.querySelectorAll('input,button').forEach(node => node.disabled = true);
    try {
      await enqueue(async () => {
        await requestCart('cart/change.js', { id: form.dataset.key, quantity });
        await refreshCartPage();
      });
    } catch (error) {
      const errorNode = document.querySelector('[data-cart-error]');
      if (errorNode) errorNode.textContent = error.message || strings.error;
      form.querySelectorAll('input,button').forEach(node => node.disabled = false);
    } finally {
      document.querySelector('[data-cart-section]')?.removeAttribute('aria-busy');
    }
  }
  function setupStickyPurchase() {
    const sticky = document.querySelector('[data-sticky-cart]');
    if (!sticky) return;
    const anchor = document.querySelector('.product [data-purchase-anchor]');
    const form = anchor?.querySelector('[data-purchase-form]');
    const slot = document.createElement('div');
    slot.className = 'sticky-purchase-slot';
    sticky.prepend(slot);
    let docked = false;
    let scheduled = false;
    const measure = () => {
      const height = Math.ceil(sticky.getBoundingClientRect().height);
      if (height > 0) document.documentElement.style.setProperty('--purchase-sticky-height', height + 'px');
    };
    const update = () => {
      scheduled = false;
      if (form) {
        const shouldDock = anchor.getBoundingClientRect().bottom <= 0;
        if (shouldDock !== docked) {
          if (shouldDock) {
            anchor.style.minHeight = anchor.getBoundingClientRect().height + 'px';
            slot.append(form);
          } else {
            anchor.append(form);
            anchor.style.minHeight = '';
          }
          docked = shouldDock;
        }
      }
      measure();
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('pageshow', schedule);
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(measure).observe(sticky);
    update();
  }
  document.addEventListener('click', event => {
    const order = event.target.closest('[data-whatsapp-order]');
    if (order) {
      event.preventDefault();
      if (pending > 0 || uncertain || !cart.item_count) return;
      location.assign('https://wa.me/971509755800?text=' + encodeURIComponent(whatsappMessage()));
      return;
    }
    const cartStep = event.target.closest('[data-cart-step]');
    if (cartStep) {
      const form = cartStep.closest('[data-cart-change]');
      if (form.closest('[aria-busy="true"]')) return;
      const input = form.querySelector('[data-cart-quantity]');
      const quantity = Math.max(0, Number(input.value) + Number(cartStep.dataset.cartStep));
      if (Number.isInteger(quantity)) changeCart(form, quantity);
      return;
    }
    const step = event.target.closest('[data-quantity-step]');
    if (!step) return;
    const form = step.closest('[data-purchase-form]');
    if (!form || form.dataset.busy) return;
    const input = form.querySelector('[name="quantity"]');
    const current = Number(input.value);
    input.value = Math.max(1, (Number.isInteger(current) ? current : 1) + Number(step.dataset.quantityStep));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.matches('[data-purchase-form]')) {
      event.preventDefault();
      if (form.dataset.busy) return;
      const values = new FormData(form);
      const quantity = Number(values.get('quantity') || 1);
      if (!Number.isInteger(quantity) || quantity < 1) return;
      const button = form.querySelector('[data-add-button]');
      const label = form.querySelector('[data-add-label]');
      const status = form.querySelector('[data-form-status]');
      form.dataset.busy = 'true';
      button.disabled = true;
      label.textContent = strings.adding;
      status.textContent = '';
      try {
        await enqueue(() => requestCart('cart/add.js', { items: [{ id: Number(values.get('id')), quantity }] }));
        status.textContent = strings.added;
        button.classList.remove('add-success');
        void button.offsetWidth;
        button.classList.add('add-success');
        const sticky = document.querySelector('[data-sticky-cart]');
        if (sticky && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          sticky.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-6px)' }, { transform: 'translateY(0)' }], { duration: 380 });
        }
        setTimeout(() => button.classList.remove('add-success'), 1000);
        showToast(strings.added);
      } catch (error) {
        status.textContent = error.message || strings.error;
        showToast(error.message || strings.error);
      } finally {
        delete form.dataset.busy;
        const option = form.querySelector('[data-variant-select]')?.selectedOptions[0];
        button.disabled = option ? option.dataset.available !== 'true' : false;
        label.textContent = button.disabled ? strings.sold : strings.add;
      }
    } else if (form.matches('[data-cart-change]')) {
      event.preventDefault();
      const quantity = event.submitter?.matches('[data-cart-remove]') ? 0 : Number(form.querySelector('[name="quantity"]').value);
      if (Number.isInteger(quantity) && quantity >= 0) await changeCart(form, quantity);
    } else if (form.matches('[data-checkout-form]') && (pending > 0 || uncertain)) {
      event.preventDefault();
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select]')) {
      const option = event.target.selectedOptions[0];
      const form = event.target.closest('[data-purchase-form]');
      
      const button = form.querySelector('[data-add-button]');
      button.disabled = !!form.dataset.busy || option.dataset.available !== 'true';
      form.querySelector('[data-add-label]').textContent = option.dataset.available === 'true' ? strings.add : strings.sold;
      form.querySelector('[data-form-status]').textContent = '';
    } else if (event.target.matches('[data-cart-quantity]')) {
      const quantity = Number(event.target.value);
      if (Number.isInteger(quantity) && quantity >= 0) changeCart(event.target.closest('[data-cart-change]'), quantity);
    }
  });
  window.addEventListener('pageshow', async event => {
    renderDates();
    if (!event.persisted) return;
    try {
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error();
      cart = await response.json();
      renderCart();
      await refreshCartPage();
    } catch { showToast(strings.error); }
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) renderDates(); });
  setInterval(renderDates, 30000);
  document.documentElement.classList.add('purchase-js');
  renderCart();
  renderDates();
  setupStickyPurchase();
})();

